import {Component, OnDestroy, OnInit} from '@angular/core';
import {PagesService} from '../../shared/services/pages.service';
import {Observable, Subject, Subscription} from 'rxjs';
import {Filial} from '../../shared/interfaces/filial';
import {SEOService} from '../../shared/services/seo.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {CmsService} from '../../cms/services/cms.service';
import {Networks} from '../../shared/models/networks.enum';
import {StoreLocatorPageService} from '../store-locator-page/store-locator-page.service';
import {Agenzia} from '../store-locator-page/interfaces/agenzia.interface';
import { finalize, takeUntil } from 'rxjs/operators';
import { LoadingService } from '../../shared/services/loading.service';
import { UrlSites } from 'src/app/enums/url-sites.enum';

@Component({
  selector: 'app-contacts-page',
  templateUrl: './contacts-page.component.html',
  styleUrls: ['./contacts-page.component.scss']
})
export class ContactsPageComponent implements OnInit, OnDestroy {
 /* hasContacts$: Observable<boolean>;
  contacts$: Observable<string>;
  filials$: Observable<Filial[]>;
*/
  private mapsBaseUrl = 'https://maps.google.com/maps/api/staticmap?zoom=14&size=300x300&maptype=roadmap&markers=color:red|';
  private mapsKey = 'AIzaSyClNmY0SgZbrgrzb8ofVxt1d3E9elwCMrc';

  private brandConfigSubscription: Subscription;
  private agenzieSubscription: Subscription;
  private getStoresSubscription: Subscription;

  brand: any;
  agencyInfo: Agenzia;
  agenciesInfo: Agenzia[];

  hasGeoNetwork: boolean = false;
  hasWtgNetwork: boolean = false;

  private unsubscribe$ = new Subject<any>();
  public hasMultipleStores = false;
  public isNetworkSite = false;

  constructor(
    private _loadingService: LoadingService,
    private sanitizer: DomSanitizer,
    private _pagesService: PagesService,
    private _seoService: SEOService,
    private _storeLocatorPageService: StoreLocatorPageService,
    private _cmsService: CmsService)
  { }


  ngOnInit(): void {
    this._seoService.setTitle('Contatti');

    this.brandConfigSubscription = this._cmsService.brandConfig$.subscribe(brand => {
      if (brand) {
        this.brand = brand;
        this.hasGeoNetwork = this.brand?.networkId === Networks.GEO;
        this.hasWtgNetwork = this.brand?.networkId === Networks.WTG;

        if (this.hasGeoNetwork) {
         /* this.hasContacts$ = this._pagesService.hasContacts();
          this.contacts$ = this._pagesService.getContacts();
          this.filials$ = this._pagesService.getFilials();*/
          this.getStoresSubscription = this._storeLocatorPageService.getStores();
          this.agenzieSubscription = this._storeLocatorPageService.storesList$.subscribe(storeList => {
            // essendo che la pagina contatti viene visualizzata solo su agenzie senza filiali, mi salvo direttamente la prima agenzia
            // recuperata dall'api per poter estrarre le varie informazioni e visualizzarle nella pagina
            this.agenciesInfo = storeList;
          });
        } else if (this.hasWtgNetwork) {
          // se WTG, recupero la lista delle agenzie wtg dall'api geoPointProfiles
          this.getStoresSubscription = this._storeLocatorPageService.getStores();
          this.agenzieSubscription = this._storeLocatorPageService.storesList$.subscribe(storeList => {
            // essendo che la pagina contatti viene visualizzata solo su agenzie senza filiali, mi salvo direttamente la prima agenzia
            // recuperata dall'api per poter estrarre le varie informazioni e visualizzarle nella pagina
            this.agencyInfo = storeList[0];
          });
        }
      }
    });
    const loadingItem = {
      id: 'contacts',
      message: 'Caricamento in corso...'
    }
    this._storeLocatorPageService.storesList$.pipe(takeUntil(this.unsubscribe$)).subscribe(storeList => {
      this._loadingService.addLoad(loadingItem);

      this.hasMultipleStores = storeList?.length > 1;

      this._cmsService.siteUrl$.pipe(takeUntil(this.unsubscribe$)).subscribe(siteUrl => {
        if (siteUrl) {
          if (siteUrl.includes(UrlSites.GEOTN)) {
            this.isNetworkSite = true;
          }
        }
        if (this.isNetworkSite || this.hasMultipleStores) {
          //redirect to 404 pageNotFound
          let url = window.location.href;
          window.location.href = url.split('contatti').join('**');
        }
      });
      setTimeout(() => this._loadingService.removeLoad(loadingItem), 3000);
      
    });
  }

  ngOnDestroy() {
    this.getStoresSubscription?.unsubscribe();
    this.brandConfigSubscription?.unsubscribe();
    this.agenzieSubscription?.unsubscribe();
  }

  getMapOpenUrl(filial): SafeResourceUrl {
    return this.sanitizer
      .bypassSecurityTrustResourceUrl(`https://www.google.it/maps?q=${filial.address},${filial.city}&ll=${filial.latitude},${filial.longitude}&z=14`);
  }

  getMapImageUrl(filial): SafeResourceUrl {
    return this.sanitizer
      .bypassSecurityTrustResourceUrl(`${this.mapsBaseUrl}${filial.latitude},${filial.longitude}&key=${this.mapsKey}`);
  }

}
